// components/EventCarousel.jsx previous
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
// import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

const EventCarousel = ({ events }) => {
  if (!events || events.length === 0) return null;

  return (
    <div className="w-full mb-10">
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true} 
        className="rounded-lg overflow-hidden shadow-lg"
      >
        {events.slice(0, 5).map((event) => (
          <SwiperSlide key={event.ref}>
            <Link to={`/event/${event.ref}`}>
              <div className="relative w-full h-[250px] sm:h-[350px] lg:h-[400px]">
                <img
                  src={event.banner || event.image}
                  alt={event.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-center px-8 text-white">
                  <span className="bg-yellow-400 text-black px-3 py-0.5 text-xs font-bold w-fit rounded">
                    THEME
                  </span>
                  <h2 className="text-lg sm:text-2xl lg:text-3xl font-semibold mt-2 max-w-[700px] leading-snug">
                    {event.title}
                  </h2>
                  <p className="text-sm mt-2">{event.location}</p>
                </div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default EventCarousel;


// // components/EventCarousel.jsx
// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";        // Only pagination CSS
// import { Pagination, Autoplay } from "swiper/modules";  // Removed Navigation
// import { Link } from "react-router-dom";

// const EventCarousel = ({ events }) => {
//   if (!events || events.length === 0) return null;

//   return (
//     <div className="w-full mb-10">
//       <Swiper
//         modules={[Pagination, Autoplay]}   // Removed Navigation
//         spaceBetween={30}
//         slidesPerView={1}
//         pagination={{
//           clickable: true,
//           dynamicBullets: true,           // Optional: makes bullets prettier
//         }}
//         autoplay={{
//           delay: 4000,
//           disableOnInteraction: false,
//         }}
//         loop={true}                        // Nice infinite loop
//         className="rounded-xl overflow-hidden shadow-2xl"
//       >
//         {events.slice(0, 5).map((event) => (
//           <SwiperSlide key={event.ref}>
//             <Link to={`/event/${event.ref}`}>
//               <div className="relative w-full h-[280px] sm:h-[380px] lg:h-[480px] cursor-pointer group">
//                 <img
//                   src={event.banner || event.image}
//                   alt={event.title}
//                   className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent flex flex-col justify-end p-6 sm:p-10 text-white">
//                   <span className="bg-yellow-400 text-black px-4 py-1 text-xs font-bold rounded-full w-fit mb-3">
//                     THEME
//                   </span>
//                   <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-4xl">
//                     {event.title}
//                   </h2>
//                   <p className="text-sm sm:text-lg mt-2 opacity-90">{event.location}</p>
//                 </div>
//               </div>
//             </Link>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//   );
// };

// export default EventCarousel;